module.exports = __webpack_public_path__ + "img/ndg.f4a69d94.png";